<div class="auth-open-wrapper">
    <app-header *ngIf="mostrarHeader"></app-header>
    <app-toast></app-toast>
    <div class="auth-open-content">
        <h2 class="auth-title">Documentos para declaração do IR</h2>
        <ng-container *ngIf="!telaCodigo">
            <p class="auth-desc">
                Vamos enviar um código de segurança para confirmar sua identidade, escolha uma opção abaixo para receber o código:
            </p>
            <form>
                <div class="auth-options">
                    <!-- Emails -->
                    <ng-container *ngFor="let email of emails; let i = index">
                        <label class="auth-option">
                            <input
                                type="radio"
                                name="option"
                                [value]="email"
                                [checked]="selectedOption === 'email' && selectedContact === email"
                                (change)="onSelectContact('email', email)" />
                            <div class="auth-option-texts">
                                <span class="auth-subtitle">Receber código por e-mail</span>
                                <span class="auth-detail">{{ emailsMascarados[i] || 'E-mail não disponível' }}</span>
                            </div>
                        </label>
                    </ng-container>

                    <!-- Telefones -->
                    <ng-container *ngFor="let telefone of telefones; let i = index">
                        <label class="auth-option">
                            <input
                                type="radio"
                                name="option"
                                [value]="telefone"
                                [checked]="selectedOption === 'sms' && selectedContact === telefone"
                                (change)="onSelectContact('sms', telefone)" />
                            <div class="auth-option-texts">
                                <span class="auth-subtitle">Receber código por SMS</span>
                                <span class="auth-detail">{{ telefonesMascarados[i] || 'Telefone não disponível' }}</span>
                            </div>
                        </label>
                    </ng-container>
                </div>
            <button type="button" class="auth-btn" (click)="enviarCodigo()" [disabled]="!selectedContact">Continuar</button>
            </form>
        </ng-container>
        <ng-container *ngIf="telaCodigo">
            <div class="codigo-validacao">
                <p class="codigo-envio">Enviamos um código de uso único para {{ contato }}<br>Digite o código recebido abaixo</p>
                <div class="codigo-label">Digite o código recebido:</div>
                        <div class="codigo-inputs">
                           <input type="text" maxlength="1" id="codigo-0" (input)="onInput(0, $event)" (keydown)="onKeydown(0, $event)" class="codigo-box" autocomplete="off" />
                           <input type="text" maxlength="1" id="codigo-1" (input)="onInput(1, $event)" (keydown)="onKeydown(1, $event)" class="codigo-box" autocomplete="off" />
                           <input type="text" maxlength="1" id="codigo-2" (input)="onInput(2, $event)" (keydown)="onKeydown(2, $event)" class="codigo-box" autocomplete="off" />
                           <input type="text" maxlength="1" id="codigo-3" (input)="onInput(3, $event)" (keydown)="onKeydown(3, $event)" class="codigo-box" autocomplete="off" />
                           <input type="text" maxlength="1" id="codigo-4" (input)="onInput(4, $event)" (keydown)="onKeydown(4, $event)" class="codigo-box" autocomplete="off" />
                           <input type="text" maxlength="1" id="codigo-5" (input)="onInput(5, $event)" (keydown)="onKeydown(5, $event)" class="codigo-box" autocomplete="off" />
                        </div>
                <div class="codigo-timer">
                    <span class="codigo-reenviar">{{ timer | number:'2.0' }}</span>
                    <button type="button" class="codigo-reenviar" [disabled]="!podeReenviar" (click)="reenviarCodigo()">_Não recebi o código</button>
                </div>
            <button type="button" class="auth-btn" (click)="validarCodigo()">Continuar</button>
            </div>
        </ng-container>
    </div>
</div>
